<template>
  <div class="row" style="margin-bottom: 1%">
    <div class="col-2">
      <label>Data </label>
      <div class="input-group input-focus">
        <input type="date" class="form-control form-input-component" v-model="data" id="data" required @input="dataValida = !!data" />
      </div>
    </div>
    <div class="col-6">
      <label>Acompanhamento</label>
      <div class="input-group input-focus">
        <textarea class="form-control form-input-component" rows="2" maxlength="1000" v-model="acompanhamento" id="acompanhamento" required></textarea>
      </div>
    </div>
  </div>
  <button type="button" class="btn btn-primary" style="display: block; margin: 0 auto; width: 10%" @click="salvar">SALVAR</button>

  <div style="margin-top: 5px">
    <a-table :dataSource="listaAcompanhamento" :columns="columns">
      <template #data="{ record }">
        <span>{{ stringData(record) }}</span>
      </template>
      <template #action="{ record }">
        <a @click="excluir(record)" alt="Excluir"> <i class="fas fa-trash-can icon-trash-can"></i></a>
      </template>
    </a-table>
  </div>
</template>

<script>
import { openNotification, typesNotification } from '@/utils/notifications';
import { createAcompanhamento, deleteAcompanhamento, getAcompanhamentoByIdRegistroAtendimento } from '@/components/service/acompanhamento';
import moment from 'moment/moment';
import { getByIdRegistroAtendimento } from '@/components/service/registroAtendimentoService';

export default {
  name: 'AtendimentoAcompanhamento',
  data() {
    return {
      fields: [],
      listaAcompanhamento: [],
      data: '',
      acompanhamento: '',
      dataValida: false,
      columns: [
        {
          title: 'Acompanhamento',
          dataIndex: 'acompanhamento',
          key: 'acompanhamento',
          slots: { customRender: 'acompanhamento' },
        },
        {
          title: 'Data',
          dataIndex: 'data',
          key: 'data',
          slots: { customRender: 'data' },
        },
        {
          title: 'Ação',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  async created() {
    this.idRegistroAtendimento = this.$route.query.id;
    await this.getAcompanhamento();
  },
  methods: {
    async getAcompanhamento() {
      await getAcompanhamentoByIdRegistroAtendimento(this.idRegistroAtendimento).then((esp) => {
        this.listaAcompanhamento = esp.data.reverse();
      });
    },

    async salvar() {
      if (!this.data || !this.acompanhamento) {
        openNotification(typesNotification.error, 'Por favor, preencha todos os campos obrigatórios.');
        return;
      }
      await createAcompanhamento(await this.monterObjeto()).then(() => {
        this.fields = [];
        this.getAcompanhamento();
        openNotification(typesNotification.success, 'Salvo com sucesso.');
      });
    },
    async monterObjeto() {
      let acompanhamentos = {};
      let registroAtendimento = {};
      let idRegistroAtendimento = this.idRegistroAtendimento;
      await getByIdRegistroAtendimento(idRegistroAtendimento).then((p) => {
        registroAtendimento = p.data;
      });
      acompanhamentos.registroAtendimento = registroAtendimento;
      acompanhamentos.acompanhamento = this.acompanhamento;
      acompanhamentos.data = this.data;

      return acompanhamentos;
    },

    async excluir(obj) {
      await deleteAcompanhamento(obj.id).then(() => {
        this.getAcompanhamento();
        openNotification(typesNotification.success, 'Exclusão efetuada com sucesso!');
      });
    },

    stringData(record) {
      return moment(record.data).format('DD/MM/YYYY');
    },
  },
};
</script>

<style scoped></style>
